import * as React from "react";
const IconPuzzle = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.4}>
      <path
        d="M20.9863 2.99243H8.98633C7.88176 2.99243 6.98633 3.88786 6.98633 4.99243V7.99243C6.98633 8.54472 6.53861 8.99243 5.98633 8.99243C4.32947 8.99243 2.98633 10.3356 2.98633 11.9924C2.98633 13.6493 4.32947 14.9924 5.98633 14.9924C6.53861 14.9924 6.98633 15.4401 6.98633 15.9924V18.9924C6.98633 20.097 7.88176 20.9924 8.98633 20.9924H10.9863C11.5386 20.9924 11.9863 20.5447 11.9863 19.9924C11.9863 18.3356 13.3295 16.9924 14.9863 16.9924C16.6432 16.9924 17.9863 18.3356 17.9863 19.9924C17.9863 20.5447 18.434 20.9924 18.9863 20.9924H20.9863C22.0909 20.9924 22.9863 20.097 22.9863 18.9924V15.9924C22.9863 15.4401 22.5386 14.9924 21.9863 14.9924C20.3295 14.9924 18.9863 13.6493 18.9863 11.9924C18.9863 10.3356 20.3295 8.99243 21.9863 8.99243C22.5386 8.99243 22.9863 8.54472 22.9863 7.99243V4.99243C22.9863 3.88786 22.0909 2.99243 20.9863 2.99243Z"
        fill={props.color || "#1C1C2C"}
      />
    </g>
  </svg>
);
export default IconPuzzle;
